module.exports = __webpack_public_path__ + "static/img/80.7a8cf1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/80.png
// module id = zr4E
// module chunks = 1